import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

import { AccommodationService } from '../accommodation.service';
import { SetAvailabilityAction } from '@/accommodation-file/_models/accommodation-list.model';

@Component({
	selector: 'app-accommodation-availability-set',
	templateUrl: './accommodation-availability-set.component.html',
	styleUrls: ['./accommodation-availability-set.component.css'],
})
export class AccommodationAvailabilitySetComponent implements OnInit {
	availabilityType: Array<object> = [
		{ id: 'A', name: 'Allotment' },
		{ id: 'G', name: 'Gwarancja' },
	];
	currency: Array<any> = [];
	roomSlaves: Array<any> = [];
	data = {
		action: null,
		currency: null,
		room: [],
		dateRange: {
			lower: null,
			upper: null,
		},
		roomSlave: [],
		cost: null,
		availabilityType: null,
		roomSlavesRemove: false,
		comment: null,
	};
	error = {
		dateRange: true,
		currency: true,
		cost: true,
		availabilityType: true,
	};

	message = '';

	readonly SetAvailabilityAction = SetAvailabilityAction;

	constructor(
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public product,
		private readonly bag: DataBagService,
		public service: AccommodationService,
		public loader: LoaderService,
		private readonly infobox: InfoboxService,
	) {}

	ngOnInit(): void {
		this.bag.get('/currency/', (result) => {
			this.currency = result.results;
		});
	}

	dialogClose(): void {
		this.dialogRef.close();
	}

	protected roomChanged(): void {
		this.data.room.forEach((room) => {
			room.roomSlaves.forEach((slave) => {
				this.roomSlaves.push({
					id: slave.id,
					name: slave.roomType.name + ' z ' + room.roomNumber,
				});
			});
		});
	}

	set() {
		if (this.data.room.length === 0) {
			this.infobox.error('Brak wybranego pokoju');
			return;
		}
		if (this.data.dateRange.lower === null || this.data.dateRange.upper === null) {
			this.infobox.error('Brak Zakresu Dat');
			return;
		}
		if (this.data.action === SetAvailabilityAction.SET && this.data.availabilityType === null) {
			this.infobox.error('Brak Rodzaju dostępności');
			return;
		}
		if (this.data.action === SetAvailabilityAction.SET && this.data.cost === null) {
			this.infobox.error('Brak Kosztu');
			return;
		}
		if (this.data.action === SetAvailabilityAction.SET && this.data.currency === null) {
			this.infobox.error('Brak Waluty');
			return;
		}
		if (
			(this.data.action === SetAvailabilityAction.LOCK_AVAILABILITY ||
				this.data.action === SetAvailabilityAction.LOCK_SELL) &&
			this.data.comment === null
		) {
			this.infobox.error('Brak Komentarza');
			return;
		}
		this.data.room.forEach((room) => {
			this.loader.show();
			switch (this.data.action) {
				case SetAvailabilityAction.SET:
					this.availabilitySet(
						{
							currency: this.data.currency,
							room: room.id,
							dateRange: this.data.dateRange,
							cost: this.data.cost,
							availabilityType: this.data.availabilityType,
							roomNumber: room.roomNumber,
						},
						(status) => {
							if (!status) {
								return;
							}
							if (!this.data.roomSlave) {
								return;
							}
							this.data.roomSlave.forEach((slave) => {
								this.availabilitySetSlave({
									roomSlave: slave.id,
									dateRange: this.data.dateRange,
									bounds: '[)',
								});
							});
						},
					);
					break;
				case SetAvailabilityAction.DELETE:
					if (this.data.roomSlavesRemove) {
						this.data.roomSlave.forEach((slave) => {
							this.availabilityRemoveSlave({
								roomSlave: slave.id,
								dateRange: this.data.dateRange,
								roomNumber: room.roomNumber,
							});
						});
					}
					this.availabilityRemove({
						room: room.id,
						dateRange: this.data.dateRange,
						bounds: '[)',
						roomNumber: room.roomNumber,
					});
					break;
				case SetAvailabilityAction.LOCK_AVAILABILITY:
					this.availabilityState({
						room: room.id,
						dateRange: this.data.dateRange,
						state: 'L',
						comment: this.data.comment,
						roomNumber: room.roomNumber,
					});
					break;
				case SetAvailabilityAction.LOCK_SELL:
					this.availabilityState({
						room: room.id,
						dateRange: this.data.dateRange,
						state: 'S',
						comment: this.data.comment,
						roomNumber: room.roomNumber,
					});
					break;
				case SetAvailabilityAction.REMOVE_BLOCKADS:
					this.availabilityStateRemove({
						room: room.id,
						dateRange: this.data.dateRange,
						roomNumber: room.roomNumber,
					});
					break;
			}
			// dorobienie zę po wykonaniu forEacha
			// if ((this.message = '')) {
			// 	this.infobox.success('Wykonane');
			// } else {
			// 	this.infobox.error(this.message);
			// }
			this.loader.hide();
		});
	}

	availabilitySet(data, callback) {
		this.bag.post('/product/room/availability/', data, (result, error, errorFull) => {
			if (!result) {
				this.error.dateRange = errorFull.dateRange ? false : true;
				this.error.availabilityType = errorFull.availabilityType ? false : true;
				this.error.cost = errorFull.cost ? false : true;
				this.error.currency = errorFull.currency ? false : true;
				this.message += data.roomNumber + ' ' + error.error;
				callback(false);
				return;
			}
			// this.changed.emit();
			this.dialogClose();
			callback(true);
			// this.infobox.success('Zapisano');
		});
	}

	availabilityRemove(data) {
		this.bag.post('/product/room/availability/remove_availability/', data, (result, error) => {
			if (!result) {
				this.error.dateRange = error.error.dateRange ? false : true;
				this.message += data.roomNumber + ' ' + error.error;
				return;
			}
			// this.changed.emit();
			this.dialogClose();
			// this.infobox.success('Usunięto');
		});
	}

	availabilitySetSlave(data) {
		this.bag.post('/product/room_slave/availability/', data, (result, error) => {
			if (!result) {
				this.error.dateRange = error.error.dateRange ? false : true;
				this.message += data.roomNumber + ' ' + error.error;
				return;
			}
			// this.changed.emit();
			this.dialogClose();
		});
		// this.infobox.success('Zapisano');
	}

	availabilityRemoveSlave(data) {
		this.bag.post('/product/room_slave/availability/remove_availability/', data, (result, error) => {
			if (!result) {
				this.error.dateRange = error.error.dateRange ? false : true;
				this.message += data.roomNumber + ' ' + error.error;
				return;
			}
			// this.changed.emit();
			this.dialogClose();
			// this.infobox.success('Zablokowano dostępność/sprzedaż');
		});
	}

	availabilityState(data) {
		this.bag.post('/product/room/availability_state/', data, (result, error, errorFull) => {
			if (!result) {
				error.error = error.error.replace(
					'dateRange: No RoomAvailability exists in this date range',
					'Nie możesz zablokować, jeżeli pokój w ogóle nie był dostępny',
				);
				error.error = error.error.replace('comment: This field may not be null', 'Uzupełnij komentarz');
				this.message += data.roomNumber + ' ' + error.error;
				return;
			}
			// this.changed.emit();
			// this.dialogClose();
			// this.infobox.success('Zablokowano dostępność/sprzedaż');
		});
	}

	availabilityStateRemove(data) {
		this.bag.post('/product/room/availability_state/remove_availability/', data, (result, error) => {
			if (!result) {
				this.error.dateRange = error.error.dateRange ? false : true;
				this.message += data.roomNumber + ' ' + error.error;
				return;
			}
			// this.changed.emit();
			this.dialogClose();
			// this.infobox.success('Usunięto');
		});
	}
}
